import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import deliveryCashService from "../../services/deliverycash/deliverycashservice";

interface Props {
  visible: boolean;
  onHide: () => void;
  setLoading: (loading: boolean) => void;
  refreshRequestsCount: () => void;
  refreshData: () => void;
  toastRef: React.RefObject<Toast>; 
}

const CashHandoverRequestsDialog: React.FC<Props> = ({
  visible,
  onHide,
  setLoading,
  refreshRequestsCount,
  refreshData,
  toastRef
  
}) => {
  const [requests, setRequests] = useState<any[]>([]);

  useEffect(() => {
    if (visible ) {
      fetchRequests();
    }
  }, [visible]);

  const fetchRequests = async () => {
    try {
     const response = await deliveryCashService.gethandoverrequests();
      setRequests(response);
    } catch (error) {
      console.error("Error fetching handover requests:", error);
      setRequests([]);
    }finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr: string) => {
    const dt = new Date(dateStr);
    return dt.toLocaleDateString("en-GB"); // e.g. 22/08/2025
  };

  const handleAccept = async (rowData: any) => {
  confirmDialog({
    message: `Are you sure you want to accept the request from ${rowData.requestSenderName}?`,
    header: "Confirm Accept",
    icon: "pi pi-exclamation-triangle",
    acceptLabel: "Yes",
    rejectLabel: "No",
    accept: async () => {
      try {
        setLoading(true);
        const response = await deliveryCashService.acceptcashhandover(rowData.id);
        console.log('accept response',response);
        if (response?.isSuccess) {
          toastRef.current?.show({
            severity: "success",
            summary: "Accepted",
            detail: response.message || `Request accepted.`,
          });
          refreshRequestsCount();
          fetchRequests();
          // refreshCashTable(); 
          refreshData(); 
        } else {
          toastRef.current?.show({
            severity: "error",
            summary: "Error",
            detail: response?.message || "Failed to accept request",
          });
        }
      } catch (error) {
        console.error("Error accepting request:", error);
        toastRef.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Something went wrong while accepting request.",
        });
      } finally {
        setLoading(false);
      }
    },
  });
};

  
   const handleReject = async (rowData: any) => {
  confirmDialog({
    message: `Are you sure you want to reject the request from ${rowData.requestSenderName}?`,
    header: "Confirm Reject",
    icon: "pi pi-exclamation-triangle",
    acceptLabel: "Yes",
    rejectLabel: "No",
    accept: async () => {
      try {
        setLoading(true);
        const response = await deliveryCashService.rejectcashhandover(rowData.id);
        console.log('reject response',response);
        if (response?.isSuccess) {
          toastRef.current?.show({
            severity: "warn",
            summary: "Rejected",
            detail: response.message || `Request rejected.`,
          });
          refreshRequestsCount();
          fetchRequests();
        } else {
          toastRef.current?.show({
            severity: "error",
            summary: "Error",
            detail: response?.message || "Failed to reject request",
          });
        }
      } catch (error) {
        console.error("Error rejecting request:", error);
        toastRef.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Something went wrong while rejecting request.",
        });
      } finally {
        setLoading(false);
      }
    },
  });
};


  const actionTemplate = (rowData: any) => (
    <div className="flex gap-2">
      <Button
        icon="pi pi-check"
        label="Accept"
        className="px-1 py-2 text-sm"
        onClick={() => handleAccept(rowData)}
      />
      <Button
        icon="pi pi-times"
        label="Reject"
        severity="danger"
        className="px-1 py-2 text-sm"
        onClick={() => handleReject(rowData)}
      />
    </div>
  );

  return (
    <>
       <ConfirmDialog />
      <Dialog
        header="Cash Handover Requests"
        visible={visible}
        onHide={onHide}
        style={{ width: "60vw" }}
        modal
      >
        {requests.length === 0 ? (
          <p>No pending cash handover requests.</p>
        ) : (
          <DataTable
            value={requests}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          >
            <Column
              field="requestDate"
              header="Requested Date"
              body={(rowData) => formatDate(rowData.requestDate)}
              style={{ width: "150px" }}
              sortable
            />
            <Column field="requestSenderName" header="Name" sortable />
            <Column field="amount" header="Amount" style={{ width: "120px" }} sortable/>
            <Column field="remarks" header="Remark" sortable/>
            <Column header="Action" body={actionTemplate} style={{ width: "180px" }} />
          </DataTable>
        )}
      </Dialog>

    </>
  );
};

export default CashHandoverRequestsDialog;
